export default "__VITE_ASSET__DrP5oK0p__"